<mat-dialog-content>
    <ngx-skeleton-loader
        class="skeleton-loader"
        *ngIf="loading"
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
        
    <ng-container *ngIf="!loading">
        <ng-container *ngIf="articleImage$ | withLoading | async as articleImage">
            <ng-template [ngIf]="articleImage.value">
                <img class="profiler" [src]="articleImage.value" style="max-width: 100%; margin: 10px 0px 20px 0px; border-radius: 15px;">
            </ng-template>
            <ng-template [ngIf]="articleImage.error">
                Error
            </ng-template>
            <ng-template [ngIf]="articleImage.loading">
                <ngx-skeleton-loader
                    class="profiler skeleton-loader"
                    count="1"
                    [theme]="{ 
                        'height.px': 50
                    }"
                ></ngx-skeleton-loader>
            </ng-template>
        </ng-container>
        
        <div class="publish-details">
            <h5>{{ article.title }}</h5>
            <span class="publish-date">
                {{ 'Published on' | translate: {Default: "Published on"} }} {{ articleVerbose.lastEditedOn | date:'medium' }}
            </span>
        </div>

        <div  class="article-content" [innerHTML]="getSafeContent()"></div>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>
        {{ 'Close' | translate: {Default: "Close"} }}
    </button>
</mat-dialog-actions>